module.exports = __webpack_public_path__ + "static/MonoramaSemiBold-12b2e159aa34ef070baf9c6b8b67e6df.woff";